import { Navigate, Route, Routes } from 'react-router'
import { Summary } from 'pages/settings/pages/compliance/pages/upgrade10DLCPackage/pages/summary/Summary.tsx'
import { Package } from '../pages/package/Package.tsx'
import { Upgrade10DLCPackageRoutes } from './type'

export const Upgrade10DLCPackageRouter = () => {
  return (
    <Routes>
      <Route index element={<Navigate to={Upgrade10DLCPackageRoutes.package} replace />} />
      <Route path={Upgrade10DLCPackageRoutes.package} element={<Package />} />
      <Route path={Upgrade10DLCPackageRoutes.summary} element={<Summary />} />
    </Routes>
  )
}
